module.exports = __webpack_public_path__ + "static/media/003-flashlight.2e52d41b.svg";